<template>
  <div class="AsistenciasPuntos">
    <md-layout md-flex="100" md-align="center">
      <md-layout md-flex-xsmall="100" md-flex-small="100" md-flex-medium="80" md-flex-large="60" md-flex-xlarge="40">
        <md-table-card class="w-100">
          <md-toolbar>
            <h1 class="md-title">
              Seleccione el turno al que desea tomar asistencia
            </h1>
          </md-toolbar>
          <md-table>
            <md-table-header>
              <md-table-row>
                <md-table-head>Punto</md-table-head>
                <md-table-head>Turno</md-table-head>
                <md-table-head>Acciones</md-table-head>
              </md-table-row>
            </md-table-header>
            <md-table-body>
              <md-table-row v-for="turno in turnos" :key="turno.id_ptu">
                <md-table-cell>{{turno.nombre_pun}}</md-table-cell>
                <md-table-cell>
                  {{ moment(turno.inicio_ptu,'h:mm:ss').format('h:mm A') }} - {{ moment(turno.termino_ptu,'h:mm:ss').format('h:mm A') }}
                </md-table-cell>
                <md-table-cell>
                  <md-button style="width:auto" class="md-raised md-accent" @click.native="irAPaseDeListaDelTurno(turno.id_ptu)">Pasar lista</md-button>
                </md-table-cell>
              </md-table-row>
            </md-table-body>
          </md-table>
        </md-table-card>
      </md-layout>
    </md-layout>
  </div>
</template>

<script>
import sha1 from "js-sha1";
import md5 from "blueimp-md5";
import Snackbar from "node-snackbar";
import moment from "moment";
export default {
  name: "AsistenciasPuntos",
  methods: {
    moment(a, b) {
      return moment(a, b);
    },
    obtenerTurnosPendientesAsistencias() {
      this.$http
        .post("asistencias/turnos", {
          token: this.$session.get("token")
        })
        .then(
          response => {
            if (response.status === 200 && "turnos" in response.body) {
              this.turnos = response.body.turnos;
            } else {
              Snackbar.show({
                text: "No se pudo establecer conexión con el servidor.",
                actionText: "Cerrar",
                pos: "top-right",
                showAction: false,
                backgroundColor: "#F44336",
                actionTextColor: "#FFF"
              });
            }
          },
          response => {
            Snackbar.show({
              text: "No se pudo establecer conexión con el servidor.",
              actionText: "Cerrar",
              pos: "top-right",
              showAction: false,
              backgroundColor: "#F44336",
              actionTextColor: "#FFF"
            });
          }
        );
    },
    irAPaseDeListaDelTurno(id_ptu) {
      this.$router.push({
        name: "AsistenciasPuntoSeleccionado",
        params: { turno: sha1(md5(id_ptu)) }
      });
    }
  },
  mounted() {
    this.obtenerTurnosPendientesAsistencias();
  },
  beforeCreate() {
    if (!this.$session.exists()) {
      this.$router.push("/login");
    }
  },
  data() {
    return {
      msg: "Inicio",
      turnos: null
    };
  }
};
</script>


// WEBPACK FOOTER //
// AsistenciasPuntos.vue?21bc37ce